/** Human-facing formatting and the parsing the YouTube Data API needs. */

/** `0:05`, `1:05`, `1:02:05`. Rubbish input formats as `0:00`. */
export function fmtTime(sec: number | undefined | null): string {
  let v = Number(sec);
  if (!Number.isFinite(v) || v < 0) v = 0;
  const s = Math.floor(v % 60);
  const m = Math.floor((v / 60) % 60);
  const h = Math.floor(v / 3600);
  const pad = (n: number) => String(n).padStart(2, '0');
  return h ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}

/** Parse the ISO-8601 durations the YouTube Data API returns (`PT4M13S`). */
export function parseISODuration(iso: string | null | undefined): number {
  if (!iso) return 0;
  const m = /^P(?:(\d+)D)?T?(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?$/.exec(iso);
  if (!m) return 0;
  return (
    (Number(m[1]) || 0) * 86400 +
    (Number(m[2]) || 0) * 3600 +
    (Number(m[3]) || 0) * 60 +
    (Number(m[4]) || 0)
  );
}

const NOISE =
  /\s*[([]\s*(official\s*(music\s*)?(video|audio|lyric[s]?\s*video)?|lyrics?|hd|4k|visuali[sz]er|mv|m\/v|audio|remaster(ed)?(\s*\d{4})?)\s*[)\]]\s*/gi;

export interface TitleParts {
  title: string;
  artist: string;
}

/** Best-effort "Artist - Title (Official Video)" split, used for YouTube items. */
export function splitTitle(raw: string, channel = ''): TitleParts {
  let title = (raw || '').trim();
  let artist = (channel || '').replace(/\s*-\s*Topic$/i, '').trim();

  title = title
    .replace(NOISE, ' ')
    .replace(/\s*[|｜]\s*official.*$/i, '')
    .replace(/\s{2,}/g, ' ')
    .trim();

  const dash = title.split(/\s+[-–—]\s+/);
  const head = dash[0] ?? '';
  if (dash.length >= 2 && head.length > 1 && head.length < 60) {
    artist = head.trim();
    title = dash.slice(1).join(' - ').trim();
  }
  return { title: title || raw || 'Unknown track', artist: artist || 'Unknown artist' };
}
